var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMailSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18.333,
    viewBox: "0 0 20 18.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "envelope",
    transform: "translate(0 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67750",
    "data-name": "Path 67750",
    d: "M19.962,5.542l-7.015,7.015a4.173,4.173,0,0,1-5.893,0L.038,5.542C.027,5.674,0,5.793,0,5.924v10A4.172,4.172,0,0,0,4.167,20.09H15.833A4.172,4.172,0,0,0,20,15.924v-10C20,5.793,19.973,5.674,19.962,5.542Z",
    transform: "translate(0 -0.757)",
    fill: "#3160d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67751",
    "data-name": "Path 67751",
    d: "M11.892,10.622,19.5,3.009A4.155,4.155,0,0,0,15.957,1H4.291A4.155,4.155,0,0,0,.744,3.009l7.612,7.613a2.506,2.506,0,0,0,3.537,0Z",
    transform: "translate(-0.124)",
    fill: "#3160d4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailSmall);
export default __webpack_public_path__ + "static/media/mailSmall.01dbb4cd54f2917b43621a6cb9436b9c.svg";
export { ForwardRef as ReactComponent };